import { AxiosError, isAxiosError } from 'axios';

interface IEmailAlreadyInUseResponse {
  message?: string;
  error?: string;
}

export class EmailAlreadyInUseError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'EmailAlreadyInUseError';
  }

  static fromAxiosError(error: unknown): EmailAlreadyInUseError | null {
    if (!isAxiosError(error)) {
      return null;
    }

    const axiosError = error as AxiosError<IEmailAlreadyInUseResponse>;

    if (axiosError.response?.status === 409) {
      const message =
        axiosError.response.data?.message ||
        axiosError.response.data?.error ||
        'An account with this email already exists.';
      return new EmailAlreadyInUseError(message);
    }

    return null;
  }
}
